<template>
    <div>
      <!-- 抽屉 drawer_info :destroy-on-close="true" -->
      <el-drawer
        :visible.sync="show"
        :with-header="false"
        :size="size"
        :modal="false"
        :before-close="handleClose"
      >
        <div class="newdrawer_box" v-loading="isloading">
          <!--  -->
          <!-- <div class="newdrawer_head" ref="getheight">
            <slot name="head"></slot>
          </div> -->
          <!--  -->
          <!--  -->
          <div class="newdrawer_content">
              <div class="newdrawer_head">
                  <slot name="head"></slot>
              </div>
              <div class="newdrawer_body">
                  <slot name="body"></slot>
              </div>
          </div>
          <!--  -->
        </div>
      </el-drawer>
      <!--  -->
    </div>
  </template>
  
  <script>
  var that;
  export default {
    name: "newpopdrawer",
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      size: {
        type: Number,
        default: 774,
      },
    },
    data() {
      return {
        isloading: false,
      };
    },
    created() {
      that = this;
    },
    watch: {
      show() {
        if (this.show) {
          this.getvanhe();
        }
      },
    },
    methods: {
      // 弹出  点击遮罩和 x 关闭弹出
      handleClose(done) {
        this.$emit("update:show", false);
      },
      getvanhe() {
        setTimeout(() => {
          let h1 = document.documentElement.clientHeight;
          let h2 = this.$refs.getheight ? this.$refs.getheight.offsetHeight : 0;
          let num = h1 - h2 - 48;
          let height = `height: ${num}px`;
          this.$emit("retuheig", { height });
        }, 300);
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  /deep/ .el-drawer__wrapper {
    padding-top: 60px;
  }
  /deep/ .el-drawer {
    box-shadow: 0 8px 10px rgba(0, 0, 0, 0.2) !important;
    border-top: 1px solid #dadee3;
  }
  @import "@/assets/css/public.scss";
  
  </style>